import React, { useState } from 'react';
import classes from './Contactus.module.css'
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import axios from 'axios';

const Contactus = ({ show, setShow, fullscreen }) => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  // ...other state if needed

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    // const [firstName, ...rest] = fullName.trim().split(' ');
    // const lastName = rest.join(' ');

    const formData = {
      name: fullName,
      email: email,
      number: phone,
      message: message,
    };

    try {
      const response = await axios.post("https://script.google.com/macros/s/AKfycbxJhXfGtH6eGA9m1gJX8sGi6skRBnVYi1M7828wT7PEb7NOr8ZFkKtFHjjvXuKc2RJERw/exec", 
       formData,
      { headers: { "Content-Type": "application/json" } }
    );
         if (response.status === 200) {
        swal("Success!", "Your message has been sent.", "success");
        setFullName('');
        setEmail('');
        setPhone('');
        setMessage('');
        setShow(false);
      } else {
        swal("Error", "There was an error submitting the form.", "error");
      }
    } catch (error) {
      swal("Error", "There was an error submitting the form.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)} className={classes.modal}>
        <Modal.Header style={{ borderBottom: 'none', marginRight: '5rem' }} closeButton>
          <Modal.Title ></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.modalcontainer}>
            <div className={classes.modalhead}>
              <p className={classes.knowutxt}>Let’s know how we can be helpful!</p>
              <p className={classes.fillfrmtxt}>Fill the form and provide the right information to get you started.</p>
            </div>
            <form className={classes.form} onSubmit={handleSubmit}>
              <div className={classes.inputcontainer}>
                <label htmlFor="name" className={classes.flnm}>Full name</label>
                <input type="text" name="fullName" placeholder='Name' required value={fullName}
                  onChange={e => setFullName(e.target.value)} />
              </div>
              <div className={classes.inputcontainer}>
                <label htmlFor="email" className={classes.flnm}>Email address</label>
                <input type="email" placeholder='Email' required value={email}
                  onChange={e => setEmail(e.target.value)} />
              </div>
              <div className={classes.inputcontainer}>
                <label htmlFor="phone" className={classes.flnm}>Phone number</label>
                <input type="text" placeholder='Phone Number' required value={phone}
                  onChange={e => setPhone(e.target.value)} />
              </div>
              <div className={classes.inputcontainer}>
                <label htmlFor="message" className={classes.flnm}>Type your message here</label>
                <textarea placeholder='Message' name="message" value={message}
                  onChange={e => setMessage(e.target.value)} required />
              </div>
              <Button variant="primary" type="submit" className={classes.submitbtn} disabled={submitting}>
                {submitting ? "Sending..." : "Send a Message"}
              </Button>
            </form>
          </div></Modal.Body>
      </Modal>
    </div>
  );
}

export default Contactus;